const SINGULAR_WORDS_ENDING_IN_S = new Set([
  'asparagus',
  'couscous',
  'hummus',
  'molasses',
]);

export function tagNameUsesPluralAgreement(tagName: string): boolean {
  const lastWord = tagName.trim().split(/\s+/).at(-1)?.toLowerCase() ?? '';

  if (!lastWord.endsWith('s') || lastWord.endsWith('ss')) {
    return false;
  }

  return !SINGULAR_WORDS_ENDING_IN_S.has(lastWord);
}
